import type React from 'react';

import cssString from 'cropperjs/dist/cropper.css';

import { css, Global } from '@change-corgi/design-system-legacy/core';

export const GlobalStyle: React.FC = () => {
	return (
		<Global
			styles={css`
				${cssString}
			`}
		/>
	);
};
